import { useState } from "react";

const faqs = [
  {
    question: "Un simple réglage suffit-il ou faut-il changer une pièce ?",
    answer: "Dans environ 60 % des cas, un réglage précis des gonds, galets et compression suffit à rendre la fenêtre parfaitement fonctionnelle. Si la pièce est usée ou cassée (crémone fendue, gond usé, galet écrasé), nous la remplaçons sur place. Notre technicien diagnostique sur place et vous explique ce qui est nécessaire avant toute intervention.",
  },
  {
    question: "Combien de temps dure l'intervention de réglage ?",
    answer: "Un réglage standard d'oscillo-battant prend entre 30 minutes et 1 heure par fenêtre. Si le remplacement d'une pièce est nécessaire, comptez 1h à 1h30. Nous intervenons du lundi au samedi, matin et après-midi, avec une possibilité d'urgence sous 24h dans le Bas-Rhin.",
  },
  {
    question: "Vous réglerez vraiment ma fenêtre même si c'est une vieille marque ?",
    answer: "Absolument. Nous travaillons sur toutes les marques, y compris les plus anciennes : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Aubi et bien d'autres. Même si la marque n'est plus identifiable, nos techniciens reconnaissent le mécanisme et trouvent la pièce adaptée. Nous avons accès à un réseau de fournisseurs spécialisés en pièces détachées de toutes générations.",
  },
  {
    question: "Le prix du réglage est-il inclus dans le devis gratuit ?",
    answer: "Oui, le diagnostic et le devis sont entièrement gratuits. Le déplacement dans tout le Bas-Rhin est aussi offert. Le prix du réglage dépend de la complexité du mécanisme et du nombre de fenêtres à régler. La pièce de remplacement, si nécessaire, est comprise dans le devis. Pas de surprise : vous savez le montant avant que nous commencions.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            FAQ — Réglage <span className="font-serif italic">oscillo-battant</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-rose-200 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-plum text-sm md:text-base pr-4">
                    {faq.question}
                  </span>
                  <div
                    className={`w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0 transition-transform ${
                      openIndex === i ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-plum" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}